import { Link, useParams } from 'react-router-dom'
import { getCapability } from '../config/site'

function CapabilityDetail() {
  const { slug } = useParams<{ slug: string }>()
  const capability = slug ? getCapability(slug) : undefined

  if (!capability) {
    return (
      <section className="hero hero--compact">
        <div className="container">
          <h1>Not found</h1>
          <p className="tagline">
            That capability doesn&apos;t exist.{' '}
            <Link className="link" to="/">
              Back home
            </Link>
            .
          </p>
        </div>
      </section>
    )
  }

  return (
    <>
      <section className="hero hero--compact">
        <div className="container">
          <span className="card__icon" aria-hidden="true">
            {capability.icon}
          </span>
          <h1>{capability.title}</h1>
          <p className="tagline">{capability.summary}</p>
        </div>
      </section>

      <section className="section">
        <div className="container container--narrow">
          <p className="lead">{capability.intro}</p>

          <div className="cards">
            {capability.points.map((point) => (
              <div className="card" key={point.heading}>
                <h3>{point.heading}</h3>
                <p>{point.body}</p>
              </div>
            ))}
          </div>

          <p className="cta-row">
            <Link className="btn btn--primary" to="/contact">
              Talk to us about {capability.title.toLowerCase()}
            </Link>{' '}
            <Link className="btn btn--ghost" to="/services">
              See our services
            </Link>
          </p>
        </div>
      </section>
    </>
  )
}

export default CapabilityDetail
